exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-video[data-v-710a7da6]{position:fixed;z-index:999;background-color:#000;background-color:rgba(0,0,0,.8)}.player[data-v-710a7da6]{max-width:100%;height:auto}.video-cover[data-v-710a7da6]{height:240px;background-position:50%}.video-cover .arrow-right[data-v-710a7da6]{width:0;height:0;border-top:20px solid transparent;border-bottom:20px solid transparent;border-left:35px solid #161b4e;margin-left:30%}@media (min-width:768px){.video-cover[data-v-710a7da6]{height:320px}}@media (min-width:992px){.video-cover[data-v-710a7da6]{height:620px}}.video-cover .modal-button .video-play[data-v-710a7da6]{height:75px;width:75px}.video-cover .modal-button .video-play img[data-v-710a7da6]{display:block;margin:0 auto;-webkit-transform:translate(5px,1px);transform:translate(5px,1px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-710a7da6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./web/app/themes/giles/resources/js/components/YouTubeModal.vue
// module id = 434
// module chunks = 0